"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollable = void 0;
const react_1 = __importDefault(require("react"));
const elements_1 = require("./elements");
exports.Scrollable = (_a) => {
    var { TrackX = elements_1.BaseTrackX, TrackY = elements_1.BaseTrackY, ThumbX = elements_1.BaseThumbX, ThumbY = elements_1.BaseThumbY, Wrapper = elements_1.BaseWrapper, Scroller = elements_1.BaseScroller } = _a, props = __rest(_a, ["TrackX", "TrackY", "ThumbX", "ThumbY", "Wrapper", "Scroller"]);
    return (react_1.default.createElement(elements_1.Container, Object.assign({}, props, { trackXProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(TrackX, Object.assign({ ref: elementRef }, itemProps)));
            },
        }, trackYProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(TrackY, Object.assign({ ref: elementRef }, itemProps)));
            },
        }, thumbXProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(ThumbX, Object.assign({ ref: elementRef }, itemProps)));
            },
        }, thumbYProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(ThumbY, Object.assign({ ref: elementRef }, itemProps)));
            },
        }, wrapperProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(Wrapper, Object.assign({ ref: elementRef }, itemProps)));
            },
        }, scrollerProps: {
            renderer: (_a) => {
                var { elementRef } = _a, itemProps = __rest(_a, ["elementRef"]);
                return (react_1.default.createElement(Scroller, Object.assign({ ref: elementRef }, itemProps)));
            },
        } })));
};
